// src/admin/InviteForm.js
import React, { useState } from 'react';
import { Card, StyledButton, AlertBox } from '../main/CommonStyles';
import styled from 'styled-components';
import apiClient from '../services/api';
import { UserPlus, Loader2, AlertTriangle } from 'lucide-react';
import { PageHeader, PageDescription } from '../main/LayoutStyles';

const Form = styled.form`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1rem;
`;

const FormField = styled.div`
    flex: 1 1 200px;
    label { display: block; font-weight: 600; margin-bottom: 0.5rem; }
    input, select {
        width: 100%;
        padding: 0.75rem;
        font-size: 1rem;
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        border-radius: ${({ theme }) => theme.borderRadius};
    }
`;

const InviteForm = ({ title, description, availableRoles, successMessage, endpoint, onStaffInvited, organizationId }) => {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState(Object.keys(availableRoles)[0]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!endpoint) {
            setError("Błąd konfiguracji: Brak zdefiniowanego endpointu API.");
            return;
        }
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            await apiClient.post(endpoint, { email, role });

            // Ustawiamy wiadomość o sukcesie w stanie komponentu
            setSuccess(successMessage || `Zaproszenie wysłane na ${email}.`);

            setEmail('');
            if (onStaffInvited) {
                onStaffInvited();
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Wystąpił błąd.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {title && <PageHeader style={{fontSize: '1.5rem', borderTop: '1px solid #e2e8f0', paddingTop: '2rem', marginTop: '2rem'}}>{title}</PageHeader>}
            {description && <PageDescription>{description}</PageDescription>}
            <Card style={{marginTop: '1rem'}}>
                <Form onSubmit={handleSubmit} noValidate>
                    <FormField>
                        <label htmlFor="email">Adres e-mail</label>
                        <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </FormField>
                    <FormField>
                        <label htmlFor="role">Rola</label>
                        <select id="role" name="role" value={role} onChange={(e) => setRole(e.target.value)}>
                            {Object.entries(availableRoles).map(([roleKey, roleLabel]) => (
                                <option key={roleKey} value={roleKey}>{roleLabel}</option>
                            ))}
                        </select>
                    </FormField>
                    <StyledButton type="submit" disabled={loading} style={{height: 'fit-content'}}>
                        {loading ? <Loader2 className="icon-spin"/> : <UserPlus/>} Zaproś
                    </StyledButton>
                </Form>

                {/* Wyświetlanie komunikatów za pomocą AlertBox */}
                {success && !loading && <AlertBox type="success" style={{marginTop: '1rem'}}>{success}</AlertBox>}
                {error && !loading && <AlertBox type="error" style={{marginTop: '1rem'}}><AlertTriangle /> {error}</AlertBox>}
            </Card>
        </div>
    );
};

export default InviteForm;